import { uiConfig as defaultUiConfig } from '../../../../../../../../../../../../common/conf/codeSystems';

const codeSystemSelectionTableUiConfig = {
    ...defaultUiConfig,
    withActions: ['view'],
    properties: {
        oid: {
            name: 'Oid',
            sortable: true,
            nullable: false,
            rowDisplay: true
        },
        name: {
            name: 'Name',
            sortable: true,
            rowDisplay: true
            // accessorOverride: (v) => {
            //     // For now we must use the formatted value until we resolve display prep
            //     if (v.mappingType === 'Value Set') {
            //         return v.valueSetDTO.name;
            //     } else if (v.mappingType === 'Code') {
            //         return v.cdsCodeSystemDTO.name;
            //     } else {
            //         return '';
            //     }
            // }
        }
    }
};

export default {
    uiConfigTable: codeSystemSelectionTableUiConfig
};
